import { useLayoutEffect, useState } from "react";

/**
 * Manually appends a div element to the dom. This
 * can be used as a replacement for a portal.
 *
 * @returns { current: HTMLDivElement }
 */
export const useManualPortal = () => {
  const [container, setContainer] = useState<HTMLDivElement | null>(null);

  // Components that use this often need it on first render and render `null` until the portal is added.
  // To prevent actually rendering that null frame, which causes flicker and layout issues,
  // we can use `useLayoutEffect` to run this effect but skip the paint and immediately rerender with the portal in place.
  useLayoutEffect(() => {
    const container = document.createElement("div");
    document.body.appendChild(container);
    setContainer(container);

    return () => {
      container.remove();
      setContainer(null);
    };
  }, []);

  return { current: container };
};
